<template>
  <div style="height: 100%;width: 100%">
    <!--  头部-->
    <el-row style="color: white;background-color: #1b8dff;font-size: 38px;text-align: center;font-weight: bold">
      <el-col :span="7">
        <div>CW 制造部</div>
      </el-col>
      <el-col :span="7">
        <div>生产概况一览</div>
      </el-col>
      <el-col :span="10">
        <div>
          {{ currentTime }}
          <el-button @click="upPage(showPage)" type="text" icon="el-icon-arrow-left-bold" style="font-size: 25px;color: white"></el-button>
          <el-button v-if="playShow === true" @click="pauseTimer" type="text" icon="el-icon-video-pause" style="font-size: 40px;color: white"></el-button>
          <el-button v-if="playShow === false" @click="startTimer" type="text" icon="el-icon-video-play" style="font-size: 40px;color: white"></el-button>
          <el-button @click="nextPage(showPage)" type="text" icon="el-icon-arrow-right-bold" style="font-size: 25px;color: white"></el-button>
        </div>
      </el-col>
    </el-row>

    <ZhiZaoKanBan1 v-if="showPage === 1"></ZhiZaoKanBan1>
    <ZhiZaoKanBan2 v-if="showPage === 2"></ZhiZaoKanBan2>
    <ZhiZaoKanBan3 v-if="showPage === 3"></ZhiZaoKanBan3>
    <ZhiZaoKanBan4 ref="ZhiZaoKanBan4" v-if="showPage === 4" @call-parent-method="parentMethod"></ZhiZaoKanBan4>
    <!--    <ZhiZaoKanBan5 v-if="showPage === 5"></ZhiZaoKanBan5>-->
    <div class="arrowDown">
      <span>
        <el-button @click="upPage(showPage)" type="text" icon="el-icon-arrow-left-bold"
                   style="font-size: 25px;"></el-button>
        <el-button v-if="playShow === true" @click="pauseTimer" type="text" icon="el-icon-video-pause"
                   style="font-size: 40px;"></el-button>
        <el-button v-if="playShow === false" @click="startTimer" type="text" icon="el-icon-video-play"
                   style="font-size: 40px;"></el-button>
        <el-button @click="nextPage(showPage)" type="text" icon="el-icon-arrow-right-bold"
                   style="font-size: 25px;"></el-button>
      </span>
    </div>
  </div>
</template>

<script>
import {useDateFormat} from "@vueuse/core";
import ZhiZaoKanBan1 from "@/views/applications/bus/make_schedule/dp/ZhiZaoKanBan1";
import ZhiZaoKanBan2 from "@/views/applications/bus/make_schedule/dp/ZhiZaoKanBan2";
import ZhiZaoKanBan3 from "@/views/applications/bus/make_schedule/dp/ZhiZaoKanBan3";
import ZhiZaoKanBan4 from "@/views/applications/bus/make_schedule/dp/ZhiZaoKanBan4";

export default {
  name: "ZhiZaoProcessKanBan",
  components: {ZhiZaoKanBan4, ZhiZaoKanBan3, ZhiZaoKanBan2, ZhiZaoKanBan1},
  data() {
    return {
      currentTime: '',
      playShow:true,
      showPage:1,
      playTimer:null,
      timerValue:100000,
      icon:false,
    }
  },
  async mounted() {
    this.timer1 = setInterval(() => {
      this.dateFormat();
    }, 1000)
    await this.getZhiZaoTimerValue();
  },
  unmounted() {
    clearInterval(this.playTimer)
  },
  methods: {
    dateFormat() {
      this.currentTime = useDateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss dddd')
    },
    nextPage(value){
      if (1 === value){
        this.showPage = 2
      }
      if (2 === value){
        this.showPage = 3
      }
      if (3 === value){
        this.showPage = 4
      }
      if (4 === value){
        this.showPage = 1
      }
      this.pauseTimer()
    },
    upPage(value) {
      if (1 === value){
        this.showPage = 4
      }
      if (2 === value){
        this.showPage = 1
      }
      if (3 === value){
        this.showPage = 2
      }
      if (4 === value){
        this.showPage = 3
      }
      this.pauseTimer()
    },
    pauseTimer() {
      this.playShow = false
      clearInterval(this.playTimer)
      if (4 === this.showPage) {
        // 通过 ref 调用子组件的方法
        this.$refs.ZhiZaoKanBan4.stopToBottom();
      }
    },
    startTimer() {
      if (4 === this.showPage && !this.playShow) {
        this.$refs.ZhiZaoKanBan4.scrollToBottom1();
      }

      if (this.showPage !== 4) {
        this.playTimer = setInterval(() => {
          let showPage = this.showPage;
          if (1 === showPage) {
            this.showPage = 2
          }
          if (2 === showPage) {
            this.showPage = 3
          }
          if (3 === showPage) {
            this.showPage = 4
          }
          if (4 === showPage) {
            this.showPage = 1
          }
        }, this.timerValue)
      }

      this.playShow = true
    },
    async getZhiZaoTimerValue() {
      this.$axios.get('mfg/assemblyProduction/getZhiZaoTimerValue').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("制造大屏切换时间为空");
        }

        this.timerValue = res.data;
        console.log("timerValue==",this.timerValue)

        this.playTimer = setInterval(() => {
          let showPage = this.showPage;
          if (1 === showPage) {
            this.showPage = 2
          }
          if (2 === showPage) {
            this.showPage = 3
          }
          if (3 === showPage) {
            this.showPage = 4
          }
          if (4 === showPage) {
            this.showPage = 1
          }
        }, this.timerValue)
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    async parentMethod(value) {
      console.log("value==",value)
      if ("clearIntervalPlayTimer" === value) {
        clearInterval(this.playTimer)
      } else {
        console.log("value==",this.showPage)
        if (1 === this.showPage){
          this.showPage = 2
        }
        if (2 === this.showPage){
          this.showPage = 3
        }
        if (3 === this.showPage){
          this.showPage = 4
        }
        if (4 === this.showPage){
          this.showPage = 1
        }
        this.startTimer()
      }
    }
  },created() {

  }
}
</script>

<style scoped>
.arrowDown {
  right: 1px;
  bottom: 1px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  border-radius: 3px;
  z-index: 1000;
}
</style>